/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from "react";
import { Box, Tab, Tabs } from "@mui/material";
import { ShiftsList } from "./ShiftsList";
import { ShiftAssignments } from "./ShiftAssignments";

// eslint-disable-next-line import/prefer-default-export
export function ShiftSettings(): React.ReactNode {
  const [activeTab, setActiveTab] = useState(0);

  return (
    <Box sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs value={activeTab} onChange={(_, v) => setActiveTab(v)}>
          <Tab label="Shift List" />
          <Tab label="Shift Assignment" />
        </Tabs>
      </Box>

      <Box flex={1} overflow="hidden">
        {activeTab === 0 && <ShiftsList />}
        {activeTab === 1 && <ShiftAssignments />}
      </Box>
    </Box>
  );
}
